import { render } from "./elem-keyboard.vue?vue&type=template&id=48e63c14&ts=true"
import script from "./elem-keyboard.vue?vue&type=script&lang=ts"
export * from "./elem-keyboard.vue?vue&type=script&lang=ts"

import "./elem-keyboard.vue?vue&type=style&index=0&id=48e63c14&lang=less"

import exportComponent from "/usr/local/share/applications/yushifu-shop-admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__